import { createFileRoute } from '@tanstack/react-router';
import { ResultsLayout } from '../../simops/-components/evaluate/ResultsLayout';

export const Route = createFileRoute('/_app/evaltool/$studyId/results')({
  component: ResultsLayout,
});
